import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EmailUnsubscribeComponent } from './email-unsubscribe.component';

const routes: Routes = [
    {
        path: 'events/unsubscribe/:token',
        component: EmailUnsubscribeComponent,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class EmailUnsubscribeRoutingModule { }
